import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { closeBoardEditorDialog, isEditingProject } from '../viewstate';
import loc from 'owa-localize';
import {
    createBoardHeaderText,
    editBoardHeaderText,
    cancelBoardButtonText,
} from './BoardEditorStrings.locstring.json';

export default observer(function BoardEditorHeader() {
    const cancelText = loc(cancelBoardButtonText);
    return (
        <div className={styles.boardEditorHeader}>
            <div>{isEditingProject() ? loc(editBoardHeaderText) : loc(createBoardHeaderText)}</div>
            <IconButton
                className={styles.closeButton}
                ariaLabel={cancelText}
                title={cancelText}
                iconProps={{ iconName: ControlIcons.Cancel, className: styles.closeIcon }}
                onClick={closeBoardEditorDialog}
            />
        </div>
    );
});
